import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { fetchScorecardByIdentifierId, resolveManualScore } from '@/reducers/tasks/tasks.actions'
import { updateMediaPlayer } from '@/reducers/media/media.redux'
import { JumpToPill } from '@/components/media/components/JumpToPill'
import { formatTime } from '@/views/Calls/components/helpers'
import { Accordion } from '@/components/accordions/Accordion'

import { TaskDrawerFooter } from './TaskDrawerFooter'
import { ScoreForm } from './ScoreForm'

export const ManualScoreDrawer = ({
  taskIsOpen,
  task,
  handlePrimaryAction,
  handleSecondaryAction,
}) => {
  const [scores, setScores] = useState({})
  const [openPanels, setOpenPanels] = useState({})
  const dispatch = useDispatch()

  const handleUpdateScores = async () => {
    const updatedScores = task.manualCriteria.map((criteria) => ({
      ...criteria,
      score: scores[criteria.id],
      scorecard_criteria_score_uuid: criteria.uuid,
    }))
    await dispatch(resolveManualScore(updatedScores, task.scorecard_id, task.organization_id))
  }

  useEffect(() => {
    dispatch(fetchScorecardByIdentifierId(task))
  }, [task.scorecard_id])

  useEffect(() => {
    if (task.manualCriteria) {
      setScores(
        task.manualCriteria.reduce((acc, criteria) => {
          acc[criteria.id] = criteria.score
          return acc
        }, {})
      )
      setOpenPanels(
        task.manualCriteria.reduce((acc, criteria) => {
          acc[criteria.id] = true
          return acc
        }, {})
      )
    }
  }, [task.manualCriteria])

  if (!task.manualCriteria) {
    return null
  }

  return (
    <>
      <div className="flex-column medium-gap">
        {task.manualCriteria.map((manualCriteria) => {
          const baseDataTestId = `manual-score-${manualCriteria.id}`

          return (
            <Accordion
              key={manualCriteria.id}
              id={`manual-score-${manualCriteria.id}`}
              expanded={openPanels[manualCriteria.id]}
              handleToggle={() =>
                setOpenPanels((prevOpenPanels) => ({
                  ...prevOpenPanels,
                  [manualCriteria.id]: !prevOpenPanels[manualCriteria.id],
                }))
              }
              title={<span data-testid={`${baseDataTestId}-header`}>{manualCriteria.name}</span>}
            >
              {manualCriteria.description && (
                <p data-testid={`${baseDataTestId}-description`}>{manualCriteria.description}</p>
              )}
              {manualCriteria.ai_anchor_text && (
                <p data-testid={`${baseDataTestId}-ai-text`}>{manualCriteria.ai_anchor_text}</p>
              )}
              {manualCriteria.ai_anchor_time && (
                <JumpToPill
                  onClick={() =>
                    dispatch(
                      updateMediaPlayer({
                        hardSelectedEvent: { timestamp: manualCriteria.ai_anchor_time },
                      })
                    )
                  }
                  formattedTime={formatTime(manualCriteria.ai_anchor_time)}
                  dataTestId={manualCriteria.id}
                />
              )}
              <ScoreForm
                baseDataTestId={baseDataTestId}
                isDisabled={!taskIsOpen}
                score={scores[manualCriteria.id]}
                setScore={(score) => setScores({ ...scores, [manualCriteria.id]: score })}
              />
            </Accordion>
          )
        })}
      </div>
      <TaskDrawerFooter
        primaryButtonDisabled={
          taskIsOpen && Object.values(scores).some((score) => score === (undefined || null))
        }
        handlePrimaryAction={async () => {
          if (taskIsOpen) {
            await handleUpdateScores()
          }
          handlePrimaryAction()
        }}
        handleSecondaryAction={handleSecondaryAction}
        primaryActionButtonText={!taskIsOpen ? 'Reopen' : 'Mark as Reviewed'}
        secondaryActionButtonText={!taskIsOpen ? null : 'Dismiss'}
      />
    </>
  )
}
